import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { IncidentHistoryResults, IncidentHistoryWebComponentSchema } from '../types';

export class IncidentHistoryBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(page: number): Promise<{ incidentsHistoryResults: IncidentHistoryResults }> {
    throw new Error('Not implemented');
  }
}
